/**
 * Add Section modal — full SECTION_TEMPLATES catalog.
 * Extracted from sectionLayouts.js in iter144 cleanup.
 */
import { mockup } from './mockups';

/** Each variant produces a list of blocks to append to the page. */
export const SECTION_TEMPLATES = {
  introduce: [
    // ── Iter 148 · 15 net-new visually-distinct intros (shape engine) ──
    { id: 'intro-centered-hero',        label: 'Centered Hero',           _previewShape: 'centered-hero',         preview: '', blocks: [{ type: 'hero',      layout: 'centered-hero',         content: { title: 'Make something they remember', tagline: 'Crafted brand identity and storytelling.', image_url: 'https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=1600&q=80', buttons: [{ text: 'Get Started', link: '#' }] } }]},
    { id: 'intro-split-image-left',     label: 'Split · Image Left',      _previewShape: 'split-image-left',      preview: '', blocks: [{ type: 'about',     layout: 'split-image-left',      content: { eyebrow: 'Issue 01', title: 'Stories worth telling slowly.', tagline: 'Issue 01 of our seasonal journal.', image_url: 'https://images.unsplash.com/photo-1517292987719-0369a794ec0f?w=1200&q=80', buttons: [{ text: 'Read', link: '#' }] } }]},
    { id: 'intro-split-image-right',    label: 'Split · Image Right',     _previewShape: 'split-image-right',     preview: '', blocks: [{ type: 'about',     layout: 'split-image-right',     content: { title: 'Hand-built for makers.', tagline: 'Tools that respect the craft. Materials that respect the earth.', image_url: 'https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?w=1200&q=80', buttons: [{ text: 'Shop', link: '#' }, { text: 'Story', link: '#' }] } }]},
    { id: 'intro-editorial-magazine',   label: 'Editorial Magazine',      _previewShape: 'editorial-magazine',    preview: '', blocks: [{ type: 'editorial', layout: 'editorial-magazine',    content: { volume: 'Volume 04', issue: 'Spring 2026', title: 'The new <em>quiet</em> luxury.', image_url: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1200&q=80' } }]},
    { id: 'intro-floating-card',        label: 'Floating Card Hero',      _previewShape: 'floating-card',         preview: '', blocks: [{ type: 'hero',      layout: 'floating-card',         content: { eyebrow: 'STUDIO', title: 'Design that breathes.', tagline: 'Available Q2 2026', image_url: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=1600&q=80', buttons: [{ text: 'Inquire', link: '#' }] } }]},
    { id: 'intro-overlapping',          label: 'Overlapping Hero',        _previewShape: 'overlapping',           preview: '', blocks: [{ type: 'hero',      layout: 'overlapping',           content: { title: 'Tomorrow begins today.', tagline: 'Atelier · 2026', image_url: 'https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?w=1600&q=80', buttons: [{ text: 'Explore', link: '#' }] } }]},
    { id: 'intro-collage',              label: 'Collage Hero',            _previewShape: 'collage',               preview: '', blocks: [{ type: 'hero',      layout: 'collage',               content: { title: 'Made with intention.', tagline: 'A collection of moments, objects, and craft.' } }]},
    { id: 'intro-large-typography',     label: 'Large Typography',        _previewShape: 'large-typography',      preview: '', blocks: [{ type: 'hero',      layout: 'large-typography',      content: { title: 'BOLD. quiet. FOREVER.', tagline: 'Brand · Strategy · Type' } }]},
    { id: 'intro-offset-asymmetric',    label: 'Offset Asymmetric',       _previewShape: 'offset-asymmetric',     preview: '', blocks: [{ type: 'hero',      layout: 'offset-asymmetric',     content: { eyebrow: 'Issue 12', title: 'Less to see. More to feel.', tagline: 'Issue 12', image_url: 'https://images.unsplash.com/photo-1517292987719-0369a794ec0f?w=1200&q=80', buttons: [{ text: 'Begin', link: '#' }] } }]},
    { id: 'intro-storytelling-bigtype', label: 'Storytelling · Big Type', _previewShape: 'storytelling-bigtype',  preview: '', blocks: [{ type: 'about',     layout: 'storytelling-bigtype',  content: { eyebrow: 'A story', title: 'We built this for the people who notice the stitching.', tagline: 'We built this for the people who notice the stitching.' } }]},
    { id: 'intro-brand-showcase',       label: 'Brand Showcase',          _previewShape: 'brand-showcase',        preview: '', blocks: [{ type: 'hero',      layout: 'brand-showcase',        content: { eyebrow: 'FEATURED', title: 'Featured: Maya', tagline: 'Spring Collection · 24 pieces', image_url: 'https://images.unsplash.com/photo-1517292987719-0369a794ec0f?w=1600&q=80', buttons: [{ text: 'View All', link: '#' }] } }]},
    { id: 'intro-video-hero',           label: 'Video Hero',              _previewShape: 'video-hero',            preview: '', blocks: [{ type: 'hero',      layout: 'video-hero',            content: { eyebrow: '2 min watch · 4K', title: 'See it in motion', tagline: '2 min watch · 4K', image_url: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=1600&q=80' } }]},
    { id: 'intro-multi-image',          label: 'Multi-Image Hero',        _previewShape: 'multi-image',           preview: '', blocks: [{ type: 'hero',      layout: 'multi-image',           content: { title: 'Three collections.', tagline: 'Spring · Summer · Fall' } }]},
    { id: 'intro-layered',              label: 'Layered Hero',            _previewShape: 'layered',               preview: '', blocks: [{ type: 'hero',      layout: 'layered',               content: { title: 'For the bold, the slow, the careful.', tagline: 'Capsule 02', image_url: 'https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=1600&q=80' } }]},
    { id: 'intro-minimal',              label: 'Minimal Hero',            _previewShape: 'minimal',               preview: '', blocks: [{ type: 'hero',      layout: 'minimal',               content: { title: 'making.', tagline: 'est. 2021 · brooklyn ny' } }]},
    // ── Iter 189c Phase B — new premium hero variants ──
    { id: 'intro-split-halfcover',      label: 'Split · Half-Cover',      _previewShape: 'split-halfcover',       preview: '', blocks: [{ type: 'hero',      layout: 'split-screen-halfcover', content: { eyebrow: 'Collection · 2026', title: 'Objects with weight. Meaning with reach.', tagline: 'Every piece hand-finished. Every story yours to tell.', image_url: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1600&q=80', buttons: [{ text: 'Shop the drop', link: '#' }, { text: 'Our story', link: '#' }] } }]},
    { id: 'intro-testimonial-hero',     label: 'Testimonial Hero',        _previewShape: 'testimonial-hero',      preview: '', blocks: [{ type: 'hero',      layout: 'testimonial-hero',      content: { quote: '"They rebuilt our brand from the ground up — and doubled our revenue in six months."', stars: 5, author_name: 'Amelia Ross', author_role: 'Founder, Kindred Studios', image_url: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&q=80', buttons: [{ text: 'Book a call', link: '#' }] } }]},

    // Iter 175 — Section Audit: removed 3 duplicate intro entries
    //   • `introduce-hero-left`     (split-image-left dup of `intro-split-image-left`)
    //   • `introduce-hero-fullbleed`(centered-hero dup of `intro-centered-hero`)
    //   • `introduce-about-split`   (split-image-right dup of `intro-split-image-right`)
    // Each was producing an identical preview shape for a redundant template.
    { id: 'introduce-marquee', label: 'Marquee Headline', _previewShape: 'marquee-banner', preview: '', blocks: [
      { type: 'marquee', content: { words: ['Indigenous Made', 'Authentic', 'Handcrafted'], speed: 'medium', separator: 'dot', bg_color: '#0F172A', text_color: '#FFFFFF', font_size: '2xl' } },
    ]},
    { id: 'introduce-banner', label: 'Announcement Banner', _previewShape: 'announcement-banner', preview: '', blocks: [
      { type: 'banner', content: { text: 'Free shipping on orders over $50', height: 'short' } },
    ]},
    { id: 'introduce-fluid', label: 'Fluid · Drag-and-Drop', _previewShape: 'fluid-engine', preview: '', blocks: [
      { type: 'fluid_canvas', content: {
        rows: 14, bg_color: '#0E0E23', fg_color: '#FFFFFF',
        children: [
          { id: 'h-' + Date.now(), type: 'heading', text: 'Build it your way', col: 3, row: 2, w: 18, h: 3 },
          { id: 'p-' + Date.now(), type: 'paragraph', text: 'Drag, resize, and drop anything anywhere on the grid.', col: 3, row: 6, w: 18, h: 2 },
          { id: 'b-' + Date.now(), type: 'button', text: 'Get Started', col: 3, row: 9, w: 5, h: 1 },
        ],
      } },
    ]},
  ],
  // ── Iter 148 · About category (8 visually-distinct layouts) ──
  about: [
    { id: 'about-founder-letter',     label: 'Founder Letter',          _previewShape: 'founder-letter',     preview: '', blocks: [{ type: 'about', layout: 'founder-letter', content: { eyebrow: 'A letter from', title: 'Sarah, our founder', tagline: "I started this in my kitchen in 2021. Today we ship to 14 countries and still hand-write every note. That hasn't changed. It won't.", image_url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&q=80', signature: 'Sarah' } }]},
    { id: 'about-values-grid',        label: 'Values · 4-Up Grid',      _previewShape: 'values-grid',        preview: '', blocks: [{ type: 'about', layout: 'values-grid', content: { title: 'What we stand for', items: [
      {title:'Craft',   text:'Made by hand, finished with care.'},
      {title:'Honesty', text:'No filler, no fluff, no shortcuts.'},
      {title:'People',  text:'Built for the humans who use it.'},
      {title:'Earth',   text:'Materials and methods we can defend.'},
    ] } }]},
    { id: 'about-timeline',           label: 'Company Timeline',        _previewShape: 'timeline',           preview: '', blocks: [{ type: 'about', layout: 'timeline', content: { title: 'Our journey', items: [
      {year:'2021', text:'Founded in Brooklyn out of a kitchen.'},
      {year:'2022', text:'Opened the first studio.'},
      {year:'2024', text:'Crossed 5,000 clients in 14 countries.'},
      {year:'2026', text:'Global expansion across three continents.'},
    ] } }]},
    { id: 'about-mission-focus',      label: 'Mission Focus',           _previewShape: 'mission-focus',      preview: '', blocks: [{ type: 'about', layout: 'mission-focus', content: { eyebrow: 'OUR MISSION', title: 'To make every interaction <em>genuinely useful</em> and <em>quietly beautiful.</em>' } }]},
    { id: 'about-statistics',         label: 'Statistics · Impact',     _previewShape: 'statistics',         preview: '', blocks: [{ type: 'about', layout: 'statistics', content: { title: 'Impact in numbers', items: [
      {value:'15K+', label:'Clients'},
      {value:'94%',  label:'Retain'},
      {value:'42',   label:'Countries'},
      {value:'5★',   label:'Avg rating'},
    ] } }]},
    { id: 'about-image-collage',      label: 'Image Collage Story',     _previewShape: 'image-collage',      preview: '', blocks: [{ type: 'about', layout: 'image-collage', content: { eyebrow: 'About us', title: 'A small studio thinking big.', text: 'We build digital things for indigenous makers, storytellers, and everyone in between. Quiet design, loud impact.', image_url: 'https://images.unsplash.com/photo-1517292987719-0369a794ec0f?w=900&q=80', image_url_2: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=900&q=80' } }]},
    { id: 'about-split-story',        label: 'Split Story',             _previewShape: 'split-story',        preview: '', blocks: [{ type: 'about', layout: 'split-story', content: { title: 'Built by hand. Backed by craft.', text: 'Every piece begins in our studio in Brooklyn. Every shipment leaves with a hand-signed card. We move slowly so the work can speak loudly.', image_url: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1600&q=80' } }]},
    { id: 'about-alternating-story',  label: 'Alternating Story Blocks', _previewShape: 'alternating-story', preview: '', blocks: [{ type: 'about', layout: 'alternating-story', content: { title: 'Our story, chapter by chapter.', tagline: 'From kitchen counter to studio.', items: [
      {year:'2021 · Begin', text:'Started in a Brooklyn apartment with one needle and one idea.', image_url:'https://images.unsplash.com/photo-1517292987719-0369a794ec0f?w=1000&q=80'},
      {year:'2024 · Grow',  text:'Moved into our first dedicated studio. Hired the first three teammates.', image_url:'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1000&q=80'},
    ] } }]},
    // ── Iter 189c Phase B — new premium About variants ──
    { id: 'about-founder-story-photo', label: 'Founder · Big Photo',     _previewShape: 'founder-story-photo', preview: '', blocks: [{ type: 'about', layout: 'founder-story-photo', content: { eyebrow: 'MEET', title: 'Maya Cortez', tagline: '"Design that respects the past and reaches for the future."', text: 'Six years ago I set out to build products that felt hand-crafted. Today we still do — every stitch, every line, every pixel.', image_url: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=1200&q=80' } }]},
    { id: 'about-collage-values',      label: 'Collage · Values',        _previewShape: 'collage-values',      preview: '', blocks: [{ type: 'about', layout: 'collage-values', content: { eyebrow: 'WHY IT MATTERS', title: 'Three things we care about.', image_url_1: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=800&q=80', image_url_2: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&q=80', image_url_3: 'https://images.unsplash.com/photo-1467043153537-a4fba2cd39ef?w=800&q=80', items: [
      { title: 'Handcraft', text: 'Every piece touched by human hands. No shortcuts.' },
      { title: 'Provenance', text: 'We name the maker on every tag. Always.' },
      { title: 'Longevity', text: 'Built to be repaired, not replaced.' },
    ] } }]},
  ],

  services: [
    // ── Iter 178f · Section Audit: every services template now renders a
    //    block whose visual matches its CategoryShapes preview tile 1:1.
    //    Editors can swap the icon/symbol on icon-features for a 96×96 image. ──
    { id: 'services-icon-features',    label: 'Icon Features · 4-up',    _previewShape: 'icon-features',     preview: '', blocks: [{ type: 'features', layout: 'icon-features-4up', content: {
      title: 'What we do',
      items: [
        { icon: '✦', title: 'Brand',    description: 'Identity systems built from the inside out.' },
        { icon: '◐', title: 'Strategy', description: 'Workshops, audits, and quarterly roadmaps.' },
        { icon: '◑', title: 'Design',   description: 'Pixel-true product, web, and print design.' },
        { icon: '✚', title: 'Build',    description: 'Production design, dev, and QA cycles.' },
      ],
    } }]},
    { id: 'services-alternating-rows', label: 'Alternating Rows',        _previewShape: 'alternating-rows',  preview: '', blocks: [{ type: 'features', layout: 'alternating-rows', content: {
      title: 'Our services',
      items: [
        { title: 'Brand Identity', text: 'Logo, type, color, voice — the full system.',           image: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=900&q=80' },
        { title: 'Web & Product',  text: 'Marketing sites, dashboards, and shipped product work.', image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=900&q=80' },
      ],
    } }]},
    { id: 'services-timeline',         label: 'Process Timeline',        _previewShape: 'timeline',          preview: '', blocks: [{ type: 'features', layout: 'process-steps-horizontal', content: {
      title: 'Our process',
      items: [
        { title: 'Discover', description: 'Workshop with stakeholders. Audit current state.' },
        { title: 'Design',   description: 'Sketch, prototype, and pressure-test direction.' },
        { title: 'Build',    description: 'Production design, dev, and QA cycles.' },
        { title: 'Launch',   description: 'Ship, measure, and iterate post-launch.' },
      ],
    } }]},
    { id: 'services-comparison',       label: 'Comparison Table',        _previewShape: 'comparison',        preview: '', blocks: [{ type: 'services', layout: 'pricing-comparison-grid', content: {
      title: 'Compare plans',
      features: ['Brand workshop', 'Logo system', 'Web design', 'Dev handoff', 'Quarterly review'],
      tiers: [
        { name: 'Starter',  price: '$2.4k', features: ['Brand workshop', 'Logo system'] },
        { name: 'Studio',   price: '$6.8k', features: ['Brand workshop', 'Logo system', 'Web design'], highlighted: true },
        { name: 'Agency',   price: '$18k',  features: ['Brand workshop', 'Logo system', 'Web design', 'Dev handoff', 'Quarterly review'] },
      ],
    } }]},
    { id: 'services-large-feature',    label: 'Large Feature · Dark',    _previewShape: 'large-feature',     preview: '', blocks: [{ type: 'features', layout: 'large-feature-dark', content: {
      eyebrow: 'Featured',
      title: 'Full Service\nBrand System',
      image_url: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=1200&q=80',
      cta_label: 'From $4,800',
      items: [
        { title: 'Strategy',  description: 'Brand positioning, voice, and architecture.' },
        { title: 'Identity',  description: 'Logo, type, color, applications.' },
        { title: 'Rollout',   description: 'Web, print, social, and team enablement.' },
      ],
    } }]},
    { id: 'services-tabbed',           label: 'Tabbed Services',         _previewShape: 'tabbed',            preview: '', blocks: [{ type: 'features', layout: 'tabbed-services-content', content: {
      title: 'Brand Identity Systems',
      tagline: 'Comprehensive identity work — logo, type, color, voice and rollout.',
      image_url: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=900&q=80',
      items: [
        { title: 'Branding', heading: 'Brand Identity Systems',    description: 'Comprehensive identity work — logo, type, color, voice and rollout.', image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=900&q=80' },
        { title: 'Design',   heading: 'Design at Every Scale',     description: 'Product, web, print, and motion design unified by a single visual language.', image: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=900&q=80' },
        { title: 'Build',    heading: 'Build & Ship Production',   description: 'Front-end, back-end, and design-system code that holds up after launch.', image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=900&q=80' },
        { title: 'Care',     heading: 'Ongoing Care & Iteration',  description: 'Monthly retainers, quarterly reviews, and continuous brand evolution.', image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=900&q=80' },
      ],
    } }]},
    { id: 'services-cards-large',      label: 'Large Service Cards',     _previewShape: 'cards-large',       preview: '', blocks: [{ type: 'features', layout: 'cards-large-2x2', content: {
      title: 'Our offerings',
      items: [
        { title: 'Brand', description: 'Identity systems built from the inside out.' },
        { title: 'Web',   description: 'Marketing sites and product UI.' },
        { title: 'SEO',   description: 'Technical SEO and content strategy.' },
        { title: 'Care',  description: 'Ongoing retainer and quarterly reviews.' },
      ],
    } }]},
    { id: 'services-pricing-focus',    label: 'Pricing-Focused',         _previewShape: 'pricing-focus',     preview: '', blocks: [{ type: 'services', layout: 'pricing-highlighted-middle', content: {
      title: 'Pick your package',
      tiers: [
        { name: 'Starter',    price: '$2.4k', features: ['Brand workshop', 'Logo system', 'Type & color'],   cta_label: 'Select' },
        { name: 'Studio',     price: '$6.8k', features: ['Everything in Starter', 'Web design', 'Style guide'], highlighted: true, cta_label: 'Select' },
        { name: 'Enterprise', price: '$18k',  features: ['Everything in Studio', 'Dev handoff', 'Launch support'], cta_label: 'Select' },
      ],
    } }]},
    // ── Iter 189c Phase B — new premium Services variants ──
    { id: 'services-bento-grid',        label: 'Bento Grid',              _previewShape: 'bento-grid',        preview: '', blocks: [{ type: 'features', layout: 'bento-grid', content: {
      eyebrow: 'HOW WE HELP', title: "Everything you need. Nothing you don't.",
      items: [
        { icon: '◐', title: 'Full brand identity', text: 'Logo, palette, type, guidelines. Everything ready to launch.' },
        { icon: '◈', title: 'Web design',    text: 'Modern, fast sites.' },
        { icon: '◉', title: 'Copy & voice',  text: 'Words that sell.' },
        { icon: '✦', title: 'Photography',   text: 'Editorial-grade shoots.' },
        { icon: '⬗', title: 'Launch strategy', text: 'From soft-open to press.' },
      ],
    } }]},
    { id: 'services-featured-showcase', label: 'Featured Showcase',       _previewShape: 'featured-showcase', preview: '', blocks: [{ type: 'features', layout: 'featured-showcase', content: {
      eyebrow: 'SIGNATURE SERVICE', title: 'End-to-end brand builds.',
      subtitle: 'From your first logo sketch to a finished storefront. Ninety days, one dedicated team, zero hand-offs.',
      benefits: ['Discovery workshop + strategy doc', 'Full identity system (logo, type, palette)', 'Custom website + product photography', 'Launch campaign copy + assets', '60-day post-launch care'],
      cta_text: 'Book a chemistry call', cta_link: '#',
      image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=80',
    } }]},
  ],
  'group-events': [
    // ── Iter 189c Phase B — new premium Events variants (using proper `events` block type) ──
    { id: 'events-grid-3up', label: 'Card Grid · 3-Up', _previewShape: 'events-grid-3up', preview: '', blocks: [
      { type: 'events', content: {
        eyebrow: 'UPCOMING',
        title: 'Events this season',
        items: [
          { date: 'MAR 12',   title: 'Founders Breakfast',      location: 'Brooklyn · NYC',      image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&q=80' },
          { date: 'APR 04',   title: 'Design Systems Workshop', location: 'Online · Live',       image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80' },
          { date: 'MAY 22',   title: 'Vendor Meetup 2026',       location: 'Toronto · Ontario',   image: 'https://images.unsplash.com/photo-1515169067868-5387ec356754?w=800&q=80' },
        ],
      } },
    ]},
    { id: 'events-agenda-list', label: 'Agenda · Vertical List', _previewShape: 'events-agenda-list', preview: '', blocks: [
      { type: 'events', layout: 'agenda-list', content: {
        eyebrow: 'CONFERENCE AGENDA',
        title: 'What\'s on the schedule',
        items: [
          { date: '09:00', title: 'Registration & Coffee', location: 'Main Lobby' },
          { date: '10:00', title: 'Opening Keynote — The Craft of Software', location: 'Auditorium A' },
          { date: '11:30', title: 'Panel · Building for Trust',              location: 'Auditorium A' },
          { date: '13:00', title: 'Lunch & Networking',                        location: 'Courtyard' },
          { date: '14:30', title: 'Workshops (Breakout Rooms)',                location: 'Rooms 101–104' },
          { date: '17:00', title: 'Closing Remarks + Reception',                location: 'Rooftop' },
        ],
      } },
    ]},
    { id: 'events-featured-hero', label: 'Featured Hero + Sidebar', _previewShape: 'events-featured-hero', preview: '', blocks: [
      { type: 'events', layout: 'featured-hero', content: {
        eyebrow: 'MAIN EVENT',
        title: 'Our biggest gathering of the year',
        items: [
          { date: 'JUN 07',   title: 'Founders Summit 2026', location: 'Toronto · Ontario', image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=1200&q=80', description: 'Two days of talks, workshops, and evening events with 400 makers.' },
          { date: 'JUN 21',   title: 'Vendor Bootcamp',       location: 'Online · Live',      image: 'https://images.unsplash.com/photo-1515169067868-5387ec356754?w=600&q=80' },
          { date: 'JUL 12',   title: 'Storefront Clinic',     location: 'NYC · Brooklyn',     image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80' },
          { date: 'AUG 03',   title: 'Design Sprint',          location: 'Online · Live',      image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600&q=80' },
        ],
      } },
    ]},
    // ── Legacy composite templates (kept for compatibility) ──
    { id: 'group-banner', label: 'Event Banner', _previewShape: 'group-banner', preview: '', blocks: [
      { type: 'banner', content: { text: 'Upcoming Event · Sat May 25', height: 'tall' } },
    ]},
    { id: 'group-rsvp', label: 'Event · RSVP', _previewShape: 'group-rsvp', preview: '', blocks: [
      { type: 'custom_text', content: { title: 'Join us', text: 'RSVP for our next gathering' } },
      { type: 'form', content: { title: 'RSVP', description: 'Let us know you are coming' } },
    ]},
    { id: 'group-gallery', label: 'Event · Photo Recap', _previewShape: 'group-gallery', preview: '', blocks: [
      { type: 'gallery', content: { title: 'Past events', images: [], layout: 'grid' } },
    ]},
  ],
  'content-memberships': [
    { id: 'cm-pitch', label: 'Membership · Pitch', _previewShape: 'cm-pitch', preview: '', blocks: [
      { type: 'about', content: { title: 'Become a Member', text: 'Unlock exclusive content & community.' } },
    ]},
    { id: 'cm-tiers', label: 'Membership · Tiers', _previewShape: 'cm-tiers', preview: '', blocks: [
      { type: 'products', content: { title: 'Plans', subtitle: 'Choose your tier' } },
    ]},
    { id: 'cm-content-feed', label: 'Content Feed', _previewShape: 'cm-content-feed', preview: '', blocks: [
      { type: 'gallery', content: { title: 'Latest Posts', images: [] } },
    ]},
    { id: 'cm-quote', label: 'Member Quote', _previewShape: 'cm-quote', preview: '', blocks: [
      { type: 'testimonial', content: { quote: 'Worth every cent.', author: 'Member' } },
    ]},
    { id: 'cm-cta', label: 'Membership · CTA', _previewShape: 'cm-cta', preview: '', blocks: [
      { type: 'banner', content: { text: 'Join today', height: 'medium' } },
    ]},
  ],
  scheduling: [
    { id: 'sched-book', label: 'Booking · Standard', _previewShape: 'sched-book', preview: '', blocks: [
      { type: 'booking', content: { title: 'Book an Appointment', subtitle: 'Choose a time' } },
    ]},
    { id: 'sched-services', label: 'Booking · Service Picker', _previewShape: 'sched-services', preview: '', blocks: [
      // Iter 178g — Differentiated from sched-book. Renders as a 4-up service
      // grid with prices so user picks a service, not a time.
      { type: 'features', layout: 'cards-large-2x2', content: { title: 'Pick a Service', items: [
        { title: 'Consultation', description: '30 min · Free' },
        { title: 'Full Session', description: '60 min · $120' },
        { title: 'Premium Package', description: '90 min · $220' },
        { title: 'Group Session', description: '60 min · $80 / person' },
      ] }},
    ]},
    { id: 'sched-hours', label: 'Hours · Banner', _previewShape: 'sched-hours', preview: '', blocks: [
      { type: 'banner', content: { text: 'Open Mon–Fri · 9–5', height: 'short' } },
    ]},
    { id: 'sched-form', label: 'Booking Inquiry', _previewShape: 'sched-form', preview: '', blocks: [
      { type: 'form', layout: 'contact', content: { title: 'Booking Inquiry', description: 'Tell us what you need and we\'ll find a time.' } },
    ]},
    { id: 'sched-faq', label: 'Booking FAQ', _previewShape: 'sched-faq', preview: '', blocks: [
      { type: 'custom_text', content: { title: 'FAQs', text: 'Frequently asked questions.' } },
    ]},
  ],
  donations: [
    // Iter 178g — Donations Section Audit. Each template now sets a distinct
    // `layout` (DonationsBlock supports centered, side-image, image-bg,
    // image-hero, marquee, stats) so the editor matches its preview tile.
    { id: 'don-tiers', label: 'Donation Tiers', _previewShape: 'don-tiers', preview: '', blocks: [
      { type: 'donations', layout: 'centered', content: { title: 'Support Our Mission', subtitle: 'Every gift counts', amounts: [25, 50, 100, 250] } },
    ]},
    { id: 'don-story', label: 'Donation Story', _previewShape: 'don-story', preview: '', blocks: [
      { type: 'donations', layout: 'side-image', content: { title: 'Why We Exist', subtitle: 'Your generosity sustains the work.', amounts: [10, 50, 100] } },
    ]},
    { id: 'don-monthly', label: 'Monthly Giving', _previewShape: 'don-monthly', preview: '', blocks: [
      { type: 'donations', layout: 'marquee', content: { title: 'Become a Monthly Supporter', subtitle: 'Recurring gifts that grow our impact.', amounts: [5, 15, 30, 50], recurring: true } },
    ]},
    { id: 'don-impact', label: 'Impact Statement', _previewShape: 'don-impact', preview: '', blocks: [
      { type: 'donations', layout: 'stats', content: { title: '12,000 lives impacted', subtitle: 'And counting. Join us.', amounts: [25, 50, 100] } },
    ]},
    { id: 'don-thanks', label: 'Donor Wall', _previewShape: 'don-thanks', preview: '', blocks: [
      { type: 'testimonial', layout: 'three-up', content: { title: 'Our generous supporters', items: [
        { quote: 'Proud to support the mission.', author: 'A. Stone' },
        { quote: 'Will give again next year.', author: 'B. Lee' },
        { quote: 'Doing important work.', author: 'C. Park' },
      ] } },
    ]},
  ],
  // ── Iter 189c Phase B · Team category (6 visually-distinct layouts) ──
  team: [
    { id: 'team-default-grid', label: 'Four-Up Grid', _previewShape: 'team-default-grid', preview: '', blocks: [
      { type: 'team', content: {
        eyebrow: 'THE CREW',
        title: 'Meet the team',
        subtitle: 'A small, tight-knit group who share a love for craft.',
        members: [
          { name: 'Amelia Ross',    role: 'Founder',       image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&q=80' },
          { name: 'Marcus Doyle',   role: 'Design Lead',   image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600&q=80' },
          { name: 'Priya Kapoor',   role: 'Engineering',   image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=600&q=80' },
          { name: 'Jordan Blake',   role: 'Operations',    image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600&q=80' },
        ],
      } },
    ]},
    { id: 'team-palm-leaf-bg', label: 'Palm-Leaf Card', _previewShape: 'team-palm-leaf-bg', preview: '', blocks: [
      { type: 'team', layout: 'palm-leaf-bg', content: {
        title: 'Our Crew',
        background_image: 'https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?w=1600&q=80',
        members: [
          { name: 'Sarah Chen',   role: 'Creative Director', photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80' },
          { name: 'Alex Rivera',  role: 'Producer',          photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80' },
          { name: 'Rae Nakamura', role: 'Photographer',      photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80' },
        ],
      } },
    ]},
    { id: 'team-square-cards', label: 'Square Cards · 8-Up', _previewShape: 'team-square-cards', preview: '', blocks: [
      { type: 'team', layout: 'square-cards', content: {
        title: 'The people behind the work',
        tagline: 'Multi-disciplinary. Deeply curious. Occasionally hilarious.',
        members: [
          { name: 'Amelia Ross',   role: 'Founder',        photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600&q=80' },
          { name: 'Marcus Doyle',  role: 'Design',         photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600&q=80' },
          { name: 'Priya Kapoor',  role: 'Engineering',    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=600&q=80' },
          { name: 'Jordan Blake',  role: 'Operations',     photo: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600&q=80' },
          { name: 'Idris Okafor',  role: 'Client Partner', photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=600&q=80' },
          { name: 'Nina Whitecrow',role: 'Writer',         photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80' },
          { name: 'Sam Ibarra',    role: 'Photographer',   photo: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=600&q=80' },
          { name: 'Rae Nakamura',  role: 'Illustrator',    photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=600&q=80' },
        ],
      } },
    ]},
    { id: 'team-violet-bg', label: 'Violet · Startup Crew', _previewShape: 'team-violet-bg', preview: '', blocks: [
      { type: 'team', layout: 'violet-bg', content: {
        title: 'Startup Crew',
        tagline: 'Small enough to move fast. Serious enough to ship.',
        members: [
          { name: 'Amelia Ross',   role: 'CEO',     photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80' },
          { name: 'Marcus Doyle',  role: 'CTO',     photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80' },
          { name: 'Priya Kapoor',  role: 'COO',     photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80' },
          { name: 'Jordan Blake',  role: 'Design',  photo: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&q=80' },
          { name: 'Idris Okafor',  role: 'Growth',  photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80' },
        ],
      } },
    ]},
    { id: 'team-org-chart-tree', label: 'Org-Chart · Tree', _previewShape: 'team-org-chart-tree', preview: '', blocks: [
      { type: 'team', layout: 'org-chart-tree', content: {
        eyebrow: 'LEADERSHIP',
        title: 'The people steering the ship',
        tagline: 'Four leads, one shared north star.',
        members: [
          { name: 'Amelia Ross',   role: 'Founder & CEO',        photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80' },
          { name: 'Sarah Chen',    role: 'Head of Design',       photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80' },
          { name: 'Marcus Doyle',  role: 'Head of Engineering',  photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80' },
          { name: 'Priya Kapoor',  role: 'Head of Operations',   photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80' },
          { name: 'Jordan Blake',  role: 'Head of Growth',       photo: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&q=80' },
        ],
      } },
    ]},
    { id: 'team-founder-spotlight', label: 'Founder Spotlight', _previewShape: 'team-founder-spotlight', preview: '', blocks: [
      { type: 'team', layout: 'founder-spotlight', content: {
        eyebrow: 'FOUNDER SPOTLIGHT',
        title: 'A studio built on quiet obsession.',
        tagline: 'Meet the small team behind every project. Multi-disciplinary, opinionated, and unafraid of a blank canvas.',
        members: [
          { name: 'Amelia Ross',    role: 'Founder & Creative Director', quote: 'We build what we wish existed. Everything else follows from that.', photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=900&q=80' },
          { name: 'Rae Nakamura',   role: 'Lead Designer',   photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300&q=80' },
          { name: 'Idris Okafor',   role: 'Senior Engineer', photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&q=80' },
          { name: 'Nina Whitecrow', role: 'Client Partner',  photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&q=80' },
          { name: 'Sam Ibarra',     role: 'Producer',        photo: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=300&q=80' },
        ],
      } },
    ]},
  ],
  images: [
    // Pre-seeded with 6 diverse generic photos so the user has a starting
    // point — they can replace each image inline from the side panel.
    { id: 'img-grid-3', label: '3-Column Grid', _previewShape: 'img-grid-3', preview: '', blocks: [
      { type: 'gallery', content: { title: '', layout: 'grid',
        images: [
          'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800&q=80',
          'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&q=80',
          'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=800&q=80',
          'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80',
          'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=80',
          'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=800&q=80',
        ],
      } },
    ]},
    { id: 'img-lookbook', label: 'Lookbook', _previewShape: 'img-lookbook', preview: '', blocks: [
      { type: 'gallery', content: { title: '', layout: 'lookbook',
        images: [
          'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1200&q=80',
          'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1200&q=80',
          'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1200&q=80',
          'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&q=80',
        ],
      } },
    ]},
    { id: 'img-carousel', label: 'Image Carousel · Scroll', _previewShape: 'img-carousel', preview: '', blocks: [
      { type: 'gallery', layout: 'carousel-scroll', content: { title: 'Featured Work',
        images: [
          'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=900&q=80',
          'https://images.unsplash.com/photo-1518770660439-4636190af475?w=900&q=80',
          'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=900&q=80',
          'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=900&q=80',
          'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=900&q=80',
          'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=900&q=80',
        ],
      }},
    ]},
    { id: 'img-marquee', label: 'Image Marquee · Auto-scroll', _previewShape: 'img-marquee', preview: '', blocks: [
      { type: 'gallery', layout: 'marquee-gallery', content: { title: 'On the Wall',
        images: [
          'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=900&q=80',
          'https://images.unsplash.com/photo-1518770660439-4636190af475?w=900&q=80',
          'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=900&q=80',
          'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=900&q=80',
          'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=900&q=80',
          'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=900&q=80',
        ],
      }},
    ]},
    { id: 'img-single-fullbleed', label: 'Full-Bleed Image', _previewShape: 'img-single-fullbleed', preview: '', blocks: [
      { type: 'single_image', content: { image_url: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1600&q=80', shape: 'fullbleed', alignment: 'center' } },
    ]},
    { id: 'img-banner', label: 'Image Banner', _previewShape: 'img-banner', preview: '', blocks: [
      { type: 'banner', content: { text: 'Caption goes here', height: 'tall' } },
    ]},
    { id: 'img-circle', label: 'Circle Image', _previewShape: 'img-circle', preview: '', blocks: [
      { type: 'single_image', content: { image_url: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800&q=80', shape: 'circle', alignment: 'center' } },
    ]},
    // ── Iter 189c Phase B — new premium Gallery variants ──
    { id: 'img-masonry-editorial', label: 'Masonry · Editorial', _previewShape: 'img-masonry-editorial', preview: '', blocks: [
      { type: 'gallery', layout: 'masonry-editorial', content: {
        eyebrow: 'THE ARCHIVE', title: 'Selected works.',
        images: [
          'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1000&q=80',
          'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1000&q=80',
          'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1000&q=80',
          'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1000&q=80',
          'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1000&q=80',
          'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1000&q=80',
          'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1000&q=80',
          'https://images.unsplash.com/photo-1467043153537-a4fba2cd39ef?w=1000&q=80',
        ],
      }},
    ]},
    { id: 'img-full-bleed-scroll', label: 'Full-Bleed · Horizontal Scroll', _previewShape: 'img-full-bleed-scroll', preview: '', blocks: [
      { type: 'gallery', layout: 'full-bleed-scroll', content: {
        eyebrow: 'IN FRAME', title: 'Scroll the story.', caption_prefix: 'Frame',
        images: [
          'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1600&q=80',
          'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1600&q=80',
          'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1600&q=80',
          'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1600&q=80',
          'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1600&q=80',
        ],
      }},
    ]},
  ],
  portfolio: [
    { id: 'port-grid', label: 'Project Grid', _previewShape: 'port-grid', preview: '', blocks: [
      { type: 'gallery', content: { title: 'Selected Work', images: [] } },
    ]},
    { id: 'port-feature', label: 'Featured Case Study', _previewShape: 'port-feature', preview: '', blocks: [
      { type: 'about', content: { title: 'Featured Project', text: 'Brief case study description.' } },
    ]},
    { id: 'port-list', label: 'Client List', _previewShape: 'port-list', preview: '', blocks: [
      { type: 'marquee', content: { words: ['Client A', 'Client B', 'Client C', 'Client D'], speed: 'slow', font_size: 'xl' } },
    ]},
    { id: 'port-quote', label: 'Quote + Image', _previewShape: 'port-quote', preview: '', blocks: [
      { type: 'testimonial', content: { quote: 'They transformed our brand.', author: 'Client Name', role: 'CEO' } },
    ]},
    { id: 'port-cta', label: 'Portfolio CTA', _previewShape: 'port-cta', preview: '', blocks: [
      { type: 'banner', content: { text: 'See more work', height: 'medium' } },
    ]},
    // ── Iter 189c Phase B — new premium Portfolio variants ──
    { id: 'port-case-study-hero', label: 'Case Study Hero', _previewShape: 'port-case-study-hero', preview: '', blocks: [
      { type: 'hero', layout: 'case-study-hero', content: {
        eyebrow: 'CASE STUDY · KINDRED',
        title: "How we tripled Kindred's conversion.",
        tagline: "A full-service brand overhaul, delivered in 6 weeks. Here's what we did — and what it moved.",
        metrics: [
          { label: 'CONVERSION',     value: '3×' },
          { label: 'REVENUE UPLIFT', value: '$2M' },
          { label: 'BUILD TIME',     value: '6 wk' },
        ],
        image_url: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=80',
        buttons: [{ text: 'Read the case study', link: '#' }],
      }},
    ]},
    { id: 'port-client-logos-wall', label: 'Client Logos Wall', _previewShape: 'port-client-logos-wall', preview: '', blocks: [
      { type: 'logos', layout: 'client-logos-wall', content: {
        eyebrow: 'IN GOOD COMPANY',
        title: "Some of the brands we've built.",
        logos: [
          { name: 'Kindred' }, { name: 'Meridian' }, { name: 'Ossature' }, { name: 'Northern' },
          { name: 'Loam & Ash' }, { name: 'Rue Alto' }, { name: 'Ferra Studio' }, { name: 'Little Lake' },
          { name: 'Wildwood' }, { name: 'Cardigan' }, { name: 'Palette Co.' }, { name: 'Notes' },
        ],
      }},
    ]},
  ],
  testimonials: [
    // Iter 178g — Testimonials Section Audit: each template now passes a `layout`
    // so TestimonialBlock renders the visual that matches its preview tile.
    { id: 't-single', label: 'Single Quote', _previewShape: 't-single', preview: '', blocks: [
      { type: 'testimonial', layout: 'single', content: { quote: 'A truly exceptional team.', author: 'Customer Name' } },
    ]},
    { id: 't-three-up', label: 'Three Up', _previewShape: 't-three-up', preview: '', blocks: [
      { type: 'testimonial', layout: 'three-up', content: { title: 'What clients say', items: [
        { quote: 'Loved it. Best decision I made all year.', author: 'A. Stone' },
        { quote: 'Would recommend to anyone shipping a brand.', author: 'B. Lee' },
        { quote: 'Five stars across the board.', author: 'C. Park' },
      ] } },
    ]},
    { id: 't-image', label: 'Quote w/ Image', _previewShape: 't-image', preview: '', blocks: [
      { type: 'testimonial', layout: 'with-image', content: { quote: 'Outstanding craftsmanship.', author: 'Name', role: 'Returning', image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=900&q=80' } },
    ]},
    { id: 't-marquee', label: 'Press Marquee', _previewShape: 't-marquee', preview: '', blocks: [
      { type: 'marquee', content: { words: ['"Stunning"', '"Best in class"', '"Highly recommend"'], speed: 'slow' } },
    ]},
    { id: 't-cta', label: 'Reviews + CTA', _previewShape: 't-cta', preview: '', blocks: [
      { type: 'testimonial', layout: 'with-cta', content: { quote: 'Game changer.', author: 'Customer', cta_label: 'Read more reviews →' } },
    ]},
    { id: 't-quote-portrait', label: 'Quote + Portrait',
      _previewShape: 't-quote-portrait', preview: '', blocks: [
      { type: 'testimonials', layout: 'single-quote-portrait', content: {
        items: [{ author: 'Sarah K.', quote: 'Best decision I made all year.', role: 'CEO, Acme Co.' }],
      }},
    ]},
    { id: 't-author-cards', label: 'Author Cards · 3-up',
      _previewShape: 't-author-cards', preview: '', blocks: [
      { type: 'testimonials', layout: 'author-bottom-card', content: {
        title: 'What our clients say',
        items: [
          { author: 'Maya L.', role: 'Designer', quote: 'Loved working with the team — clear comms and beautiful output.' },
          { author: 'Jordan T.', role: 'Founder', quote: 'Helped us ship 3× faster. Top-tier execution.' },
          { author: 'Alex R.', role: 'PM', quote: 'Reliable, kind, and pushes the work higher every iteration.' },
        ],
      }},
    ]},
    // ── Iter 189c Phase B — new premium Testimonials variants ──
    { id: 't-wall-of-love', label: 'Wall of Love',
      _previewShape: 't-wall-of-love', preview: '', blocks: [
      { type: 'testimonials', layout: 'wall-of-love', content: {
        eyebrow: 'LOVED BY THE CRAFT', title: 'A wall of love.',
        items: [
          { author: 'Maya L.', role: 'Designer',   quote: 'Loved every second of working with them.', stars: 5, image_url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=70' },
          { author: 'Jordan T.', role: 'Founder',  quote: 'Helped us ship 3× faster. Top-tier execution.', stars: 5 },
          { author: 'Alex R.',   role: 'PM',       quote: 'Reliable, kind, and pushes the work higher every iteration.', stars: 5 },
          { author: 'Sam K.',    role: 'Marketing',quote: 'The strategy work alone was worth 10× what we paid.', stars: 5, image_url: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&q=70' },
          { author: 'Priya V.',  role: 'Ops',      quote: 'They just get it. Handled every curveball with grace.', stars: 5 },
          { author: 'Leo S.',    role: 'CTO',      quote: 'Best design partner we\'ve worked with in a decade.', stars: 5 },
        ],
      }},
    ]},
    { id: 't-interview-hero', label: 'Interview Hero',
      _previewShape: 't-interview-hero', preview: '', blocks: [
      { type: 'testimonials', layout: 'interview-hero', content: {
        eyebrow: 'INTERVIEW', publication: 'FEATURED IN — MONOCLE 24',
        items: [{
          question: 'How did the rebrand change your business?',
          answer:  'It was night and day. Within two months we went from being one of a dozen competitors to being the one people mentioned by name. The site alone drove a 3× conversion lift — and that\'s before the press coverage started.',
          author: 'Amelia Ross', role: 'Founder, Kindred Studios',
          image_url: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=1200&q=80',
        }],
      }},
    ]},
  ],
  videos: [
    // Iter 178g — Videos Section Audit: each template now passes a `layout`
    // so VideoBlock renders the visual that matches its preview tile.
    { id: 'v-hero', label: 'Video Hero', _previewShape: 'v-hero', preview: '', blocks: [
      { type: 'video', layout: 'hero', content: { title: 'Watch our story', video_url: '' } },
    ]},
    { id: 'v-grid', label: 'Video Grid', _previewShape: 'v-grid', preview: '', blocks: [
      { type: 'video', layout: 'grid', content: { title: 'Featured videos', videos: [
        { title: 'Behind the scenes' }, { title: 'Customer stories' },
        { title: 'How it\'s made' }, { title: 'Live event' },
      ] } },
    ]},
    { id: 'v-embed', label: 'YouTube Embed', _previewShape: 'v-embed', preview: '', blocks: [
      { type: 'embed', content: { url: '', title: 'Watch our story' } },
    ]},
    { id: 'v-testimonial', label: 'Video Testimonial', _previewShape: 'v-testimonial', preview: '', blocks: [
      { type: 'video', layout: 'testimonial', content: { title: 'Hear from our customers', quote: '"Best decision we made for our business. Truly transformative."', author: 'Sarah K., CEO', video_url: '' } },
    ]},
    { id: 'v-banner', label: 'Video Banner', _previewShape: 'v-banner', preview: '', blocks: [
      { type: 'video', layout: 'banner', content: { title: 'Cinematic banner', subtitle: 'Tap to play', video_url: '' } },
    ]},
  ],
  calendar: [
    { id: 'cal-month', label: 'Month View', _previewShape: 'cal-month', preview: '', blocks: [
      { type: 'booking', content: { title: 'Upcoming Events' } },
    ]},
    { id: 'cal-list', label: 'Event List', _previewShape: 'cal-list', preview: '', blocks: [
      { type: 'custom_text', content: { title: 'Calendar', text: 'Upcoming dates' } },
    ]},
    { id: 'cal-banner', label: 'Save the Date', _previewShape: 'cal-banner', preview: '', blocks: [
      { type: 'banner', content: { text: 'Save the date · Aug 12', height: 'medium' } },
    ]},
    { id: 'cal-rsvp', label: 'RSVP Form', _previewShape: 'cal-rsvp', preview: '', blocks: [
      { type: 'form', content: { title: 'RSVP' } },
    ]},
    { id: 'cal-feature', label: 'Featured Event', _previewShape: 'cal-feature', preview: '', blocks: [
      { type: 'about', content: { title: 'Featured Event', text: 'Details about the headline event.' } },
    ]},
  ],
  menus: [
    { id: 'menu-list', label: 'Menu List', _previewShape: 'menu-list', preview: '', blocks: [
      { type: 'custom_text', content: { title: 'Menu', text: 'Dish · price · description (one per line)\nWagyu Burger · $18\nTuna Tartare · $22\nTruffle Pasta · $28\nCrème Brûlée · $12' } },
    ]},
    { id: 'menu-grid', label: 'Menu Grid', _previewShape: 'menu-grid', preview: '', blocks: [
      { type: 'gallery', content: { title: 'Menu', images: [] } },
    ]},
    { id: 'menu-feature', label: 'Featured Dish', _previewShape: 'menu-feature', preview: '', blocks: [
      { type: 'about', content: { title: 'Chef\'s Pick', text: 'Description of the signature plate.' } },
    ]},
    { id: 'menu-prix', label: 'Prix Fixe', _previewShape: 'menu-prix', preview: '', blocks: [
      // Iter 178g — Differentiated from menu-list. Renders as a pricing
      // panel so the prix-fixe tasting tier is visually distinct.
      { type: 'services', layout: 'pricing-highlighted-middle', content: { title: 'Prix Fixe · Tasting Menu', tiers: [
        { name: '3 Course',  price: '$55', features: ['Appetizer', 'Entrée', 'Dessert'] },
        { name: '5 Course',  price: '$85', features: ['Amuse', 'Appetizer', 'Entrée', 'Cheese', 'Dessert'], highlighted: true, cta_label: 'Reserve' },
        { name: 'Pairing',   price: '+$45', features: ['Wine pairing per course'] },
      ] } },
    ]},
    { id: 'menu-book', label: 'Reservations', _previewShape: 'menu-book', preview: '', blocks: [
      { type: 'booking', content: { title: 'Book a Table' } },
    ]},
  ],
  audio: [
    { id: 'au-player', label: 'Audio Player', _previewShape: 'au-player', preview: '', blocks: [
      { type: 'embed', content: { url: '', title: 'Listen' } },
    ]},
    { id: 'au-playlist', label: 'Playlist', _previewShape: 'au-playlist', preview: '', blocks: [
      // Iter 178g — Differentiated from au-player. Renders a track list
      // so the user immediately sees a multi-episode/song layout.
      { type: 'custom_text', content: { title: 'Latest Episodes', text: '01 · Welcome to the show — 12:34\n02 · The art of slow craft — 28:11\n03 · Building from your living room — 41:02\n04 · How to ship calmly — 19:47' } },
    ]},
    { id: 'au-feature', label: 'Featured Track', _previewShape: 'au-feature', preview: '', blocks: [
      { type: 'about', content: { title: 'New Single', text: 'Stream now everywhere.' } },
    ]},
    { id: 'au-tour', label: 'Tour Dates', _previewShape: 'au-tour', preview: '', blocks: [
      { type: 'custom_text', content: { title: 'Tour Dates', text: 'City · Date · Venue' } },
    ]},
    { id: 'au-cta', label: 'Follow CTA', _previewShape: 'au-cta', preview: '', blocks: [
      { type: 'banner', content: { text: 'Follow on Spotify · Apple Music', height: 'short' } },
    ]},
  ],
  charts: [
    { id: 'ch-stats', label: 'Stat Highlights', _previewShape: 'ch-stats', preview: '', blocks: [
      { type: 'custom_text', content: { title: '500K+ customers · 4.9★ rating', text: '', alignment: 'center' } },
    ]},
    { id: 'ch-growth', label: 'Growth Story', _previewShape: 'ch-growth', preview: '', blocks: [
      { type: 'about', content: { title: 'By the Numbers', text: 'Our impact at a glance.' } },
    ]},
    { id: 'ch-testimonial-stat', label: 'Stat + Quote', _previewShape: 'ch-testimonial-stat', preview: '', blocks: [
      { type: 'testimonial', content: { quote: '4.9 stars across 2,400 reviews', author: '' } },
    ]},
    { id: 'ch-banner', label: 'Big Number Banner', _previewShape: 'ch-banner', preview: '', blocks: [
      { type: 'banner', content: { text: '12,000+ orders shipped', height: 'medium' } },
    ]},
    { id: 'ch-cta', label: 'Numbers CTA', _previewShape: 'ch-cta', preview: '', blocks: [
      // Iter 178i — Differentiated from ch-banner. Renders a full-bleed dark
      // CTA section with a primary button, not a thin banner strip.
      { type: 'cta', content: {
        title: 'Join 12,000+ customers',
        subtitle: 'See why teams of every size choose us.',
        buttons: [{ text: 'Get Started', link: '#', color: '#8B5CF6' }],
      } },
    ]},
  ],
  forms: [
    // Iter 178g — Forms Section Audit: each template now passes a `layout`
    // so FormBlock renders the visual that matches its preview tile.
    { id: 'f-contact', label: 'Contact Form', _previewShape: 'f-contact', preview: '', blocks: [
      { type: 'form', layout: 'contact', content: { title: 'Get in touch', description: 'We\'d love to hear from you' } },
    ]},
    { id: 'f-quote', label: 'Quote Request', _previewShape: 'f-quote', preview: '', blocks: [
      { type: 'form', layout: 'quote', content: { title: 'Request a Quote', description: 'Tell us about your project and we\'ll come back with an estimate.' } },
    ]},
    { id: 'f-feedback', label: 'Feedback Form', _previewShape: 'f-feedback', preview: '', blocks: [
      { type: 'form', layout: 'feedback', content: { title: 'Tell us what you think', description: 'Rate your experience — anonymous if you prefer.' } },
    ]},
    { id: 'f-rsvp', label: 'RSVP Form', _previewShape: 'f-rsvp', preview: '', blocks: [
      { type: 'form', layout: 'rsvp', content: { title: 'RSVP', description: 'Will you be joining us?' } },
    ]},
    { id: 'f-survey', label: 'Survey', _previewShape: 'f-survey', preview: '', blocks: [
      { type: 'form', layout: 'survey', content: { title: 'How likely are you to recommend us?' } },
    ]},
    // ── Iter 189c Phase B — new premium Form variant ──────────────────
    { id: 'f-multi-step', label: 'Multi-Step · Intake Wizard', _previewShape: 'f-multi-step', preview: '', blocks: [
      { type: 'form', layout: 'multi-step', content: {
        eyebrow: 'PROJECT INTAKE',
        title: 'Tell us about your project',
        tagline: "It's only 4 quick steps — under two minutes.",
        active_step: 1,
        steps: [
          { label: 'Your Info',   fields: ['Full Name', 'Email'] },
          { label: 'Project',      fields: ['Project Type', 'Timeline'] },
          { label: 'Budget',       fields: ['Budget Range', 'Notes'] },
          { label: 'Review',        fields: [] },
        ],
      } },
    ]},
  ],
  newsletter: [
    // Iter 178g — Newsletter Section Audit: each template now passes a `layout`
    // so SignupBlock renders the visual that matches its preview tile.
    { id: 'n-inline', label: 'Inline Signup', _previewShape: 'n-inline', preview: '', blocks: [
      { type: 'signup', layout: 'inline', content: { title: 'Stay in the loop', subtitle: 'Get updates monthly' } },
    ]},
    { id: 'n-banner', label: 'Bold Banner', _previewShape: 'n-banner', preview: '', blocks: [
      { type: 'signup', layout: 'banner', content: { title: 'Subscribe', subtitle: 'Never miss a drop' } },
    ]},
    { id: 'n-incentive', label: 'Incentive Signup', _previewShape: 'n-incentive', preview: '', blocks: [
      { type: 'signup', layout: 'incentive', content: { title: 'Get 10% off your first order', subtitle: 'Just enter your email to claim' } },
    ]},
    { id: 'n-footer', label: 'Footer Signup', _previewShape: 'n-footer', preview: '', blocks: [
      { type: 'signup', layout: 'footer', content: { title: 'Newsletter', subtitle: 'Weekly digest in your inbox' } },
    ]},
    { id: 'n-launch', label: 'Launch Notify', _previewShape: 'n-launch', preview: '', blocks: [
      { type: 'signup', layout: 'launch', content: { title: 'Get notified at launch', subtitle: 'Coming Q2 2026' } },
    ]},
    // ── Iter 189c Phase B — new premium Newsletter variant ──────────
    { id: 'n-magazine-inline', label: 'Magazine · Inline Signup', _previewShape: 'n-magazine-inline', preview: '', blocks: [
      { type: 'signup', layout: 'magazine-inline', content: {
        title: 'Stories for people who notice the stitching.',
        subtitle: 'A free monthly dispatch — long-form essays, studio visits, and quiet obsessions. One email, first Sunday of the month.',
        cover_image: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=800&q=80',
      } },
    ]},
  ],
  social: [
    { id: 's-marquee', label: 'Social Marquee', _previewShape: 's-marquee', preview: '', blocks: [
      { type: 'marquee', content: { words: ['@yourhandle', 'Instagram', 'TikTok', 'Twitter'], font_size: 'xl' } },
    ]},
    { id: 's-banner', label: 'Follow Banner', _previewShape: 's-banner', preview: '', blocks: [
      { type: 'banner', content: { text: 'Follow us @yourhandle', height: 'short' } },
    ]},
    { id: 's-embed', label: 'Social Embed', _previewShape: 's-embed', preview: '', blocks: [
      { type: 'embed', content: { url: '', title: 'Latest from social' } },
    ]},
    { id: 's-grid', label: 'Social Grid', _previewShape: 's-grid', preview: '', blocks: [
      { type: 'gallery', content: { title: 'From the Feed', images: [] } },
    ]},
    { id: 's-cta', label: 'Social CTA', _previewShape: 's-cta', preview: '', blocks: [
      // Iter 178i — Differentiated from s-banner. Renders a full-bleed dark
      // CTA section with a primary button — clearer call-to-action vs a strip.
      { type: 'cta', content: {
        title: 'Tag us in your photos',
        subtitle: 'We re-share the best each week.',
        buttons: [{ text: 'Follow on Instagram', link: '#', color: '#EC4899' }],
      } },
    ]},
  ],

  // ── NEW Phase 2: Shop / Storefront ─────────────────────────────────────
  shop: [
    { id: 'shop-grid-3col', label: 'Product Grid · 3 Col Cards',
      _previewShape: 'shop-3col', preview: '', blocks: [
      { type: 'product_grid', layout: 'three-col-cards', content: {
        title: 'Best-Selling Products', tagline: 'Hand-picked favorites this season.',
        products: [
          { name: 'Beaded Earrings', price: '$48', category: 'Jewelry' },
          { name: 'Hand-woven Bag', price: '$120', category: 'Accessories' },
          { name: 'Sage Bundle', price: '$24', category: 'Ceremony' },
          { name: 'Star Quilt', price: '$280', category: 'Home' },
          { name: 'Turquoise Cuff', price: '$95', category: 'Jewelry' },
          { name: 'Birchbark Box', price: '$65', category: 'Home' },
        ],
      }},
    ]},
    { id: 'shop-grid-4col', label: 'Product Grid · 4 Col Clean',
      _previewShape: 'shop-4col', preview: '', blocks: [
      { type: 'product_grid', layout: 'four-col-clean', content: {
        title: 'Latest Products & Accessories',
        products: Array.from({length:8}).map((_,i)=>({ name:`Item ${i+1}`, price:`$${(i+1)*15}` })),
      }},
    ]},
    { id: 'shop-grid-swatches', label: 'Product Grid · With Color Swatches',
      _previewShape: 'shop-swatches', preview: '', blocks: [
      { type: 'product_grid', layout: 'with-color-swatches', content: {
        title: 'Your Daily Dose of Inspiration',
        products: Array.from({length:8}).map((_,i)=>({ name:`Style ${i+1}`, price:`$${39 + i*10}`, swatches:['#EF4444','#3B82F6','#10B981','#0E0E23'] })),
      }},
    ]},
    { id: 'shop-pdp-classic', label: 'Product Detail · Classic',
      _previewShape: 'shop-pdp-classic', preview: '', blocks: [
      { type: 'product_detail', layout: 'left-thumbs-right-info', content: {
        product: { name: 'Featured Product', price: '$199', category: 'Featured',
          description: 'Handcrafted with care. Made by an Indigenous-owned business.' },
      }},
    ]},
    { id: 'shop-pdp-fashion', label: 'Product Detail · Fashion',
      _previewShape: 'shop-pdp-fashion', preview: '', blocks: [
      { type: 'product_detail', layout: 'two-col-fashion', content: {
        product: { name: 'Braided Shoulder Bag', price: '$220', category: 'Bags',
          description: 'Buttery leather, hand-braided strap.',
          sizes: ['S','M','L'], swatches: ['#7C2D12','#0E0E23','#A78BFA'] },
      }},
    ]},
    { id: 'shop-cart', label: 'Shopping Cart',
      _previewShape: 'shop-cart', preview: '', blocks: [
      { type: 'cart_table', layout: 'line-items', content: {
        title: 'Your Cart',
        items: [
          { name:'Sample Product A', price: 29.99, qty: 1 },
          { name:'Sample Product B', price: 49.99, qty: 2 },
        ],
      }},
    ]},
    { id: 'shop-category-filter', label: 'Category · With Filter Sidebar',
      _previewShape: 'shop-cat-filter', preview: '', blocks: [
      { type: 'product_grid', layout: 'category-with-filter-sidebar', content: {
        title: 'Browse Collection',
        products: Array.from({length:9}).map((_,i)=>({ name:`Item ${i+1}`, price:`$${(i+1)*15}` })),
      }},
    ]},
    { id: 'shop-gradient-promos', label: 'Gradient Promo · Twin',
      _previewShape: 'shop-promos', preview: '', blocks: [
      { type: 'product_grid', layout: 'gradient-promo-twin', content: {
        promos: [
          { title:'Collect your unique feature', tagline:'Limited edition products.', button:'Shop Now' },
          { title:'Take 75% Discount', tagline:'Storewide sale ends Sunday.', button:'Browse Sale' },
        ],
      }},
    ]},
    // ── Iter 189c Phase B — new premium Products variants ──
    { id: 'shop-dual-collection', label: 'Dual Collection · Split',
      _previewShape: 'shop-dual-collection', preview: '', blocks: [
      { type: 'product_grid', layout: 'dual-collection-split', content: {
        collections: [
          { name: 'Fine Jewelry', tagline: 'Heirloom pieces, hand-set.', cta: 'Shop the Fine', image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=1000&q=80' },
          { name: 'Everyday',     tagline: 'Made for wearing all week long.', cta: 'Shop Everyday',    image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=1000&q=80' },
        ],
      }},
    ]},
    { id: 'shop-editorial-lookbook', label: 'Editorial Lookbook',
      _previewShape: 'shop-editorial-lookbook', preview: '', blocks: [
      { type: 'product_grid', layout: 'editorial-lookbook', content: {
        eyebrow: 'THE LOOKBOOK',
        title: 'Quiet objects, loud stories.',
        tagline: 'Six new pieces. One long weekend of storytelling. Every purchase supports a Native maker.',
        products: [
          { name: 'The Editorial', price: '$220', image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=1200&q=80' },
          { name: 'Cuff',  price: '$95',  image: 'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?w=600&q=80' },
          { name: 'Ring',  price: '$65',  image: 'https://images.unsplash.com/photo-1600721391776-b5cd0e0048f9?w=600&q=80' },
          { name: 'Charm', price: '$48',  image: 'https://images.unsplash.com/photo-1571678058829-1d1c9d33d089?w=600&q=80' },
        ],
      }},
    ]},
  ],

  // ── NEW Phase 2: Pricing ───────────────────────────────────────────────
  pricing: [
    { id: 'pricing-tabs', label: 'Pricing · Tabbed Plans',
      _previewShape: 'pricing-tabs', preview: '', blocks: [
      { type: 'services', layout: 'pricing-tabs', content: {
        title: 'Simple, Flexible Pricing', tagline: 'Pick the plan that fits.',
        tiers: [
          { name:'Starter', price:'$0', features:['Up to 3 projects','Basic analytics','Community support'] },
          { name:'Pro', price:'$19', features:['Unlimited projects','Advanced analytics','Priority support','Custom domain'], highlighted:true },
          { name:'Master', price:'$49', features:['Everything in Pro','White-label','API access','Dedicated CSM'] },
        ],
      }},
    ]},
    { id: 'pricing-compare', label: 'Pricing · Compare Grid',
      _previewShape: 'pricing-compare', preview: '', blocks: [
      { type: 'services', layout: 'pricing-comparison-grid', content: {
        title: 'Compare Plans',
        tiers: [
          { name:'Starter', price:'$0', features:['Feature 1','Feature 2'] },
          { name:'Pro', price:'$19', features:['Feature 1','Feature 2','Feature 3','Feature 4'] },
          { name:'Master', price:'$49', features:['Feature 1','Feature 2','Feature 3','Feature 4','Feature 5','Feature 6'] },
        ],
        features: ['Custom domain','Analytics','Priority support','API access','White-label','Dedicated CSM'],
      }},
    ]},
    { id: 'pricing-payg', label: 'Pricing · Pay As You Go',
      _previewShape: 'pricing-payg', preview: '', blocks: [
      { type: 'data_table', layout: 'pay-as-you-go', content: {
        title: 'Pay as you go', tagline: 'Only pay for what you use.',
        columns: ['Tier','Usage','Price'],
        rows: [
          { tier:'Free', usage:'Up to 100 / mo', price:'$0' },
          { tier:'Starter', usage:'100 – 1K / mo', price:'$9' },
          { tier:'Growth', usage:'1K – 10K / mo', price:'$29' },
          { tier:'Scale', usage:'10K – 100K / mo', price:'$99' },
          { tier:'Enterprise', usage:'100K+ / mo', price:'Custom' },
        ],
        aside_label:'Easy Start', aside_text:'Lock in your tier today, scale anytime.',
      }},
    ]},
    { id: 'pricing-feature-spec', label: 'Feature Spec Table',
      _previewShape: 'pricing-feature-spec', preview: '', blocks: [
      { type: 'data_table', layout: 'feature-spec', content: {
        title: "What's Inside?",
        rows: [
          { tier:'CPU', usage:'Quad-core 2.4 GHz', price:'Included' },
          { tier:'Memory', usage:'16 GB DDR5', price:'Included' },
          { tier:'Storage', usage:'512 GB NVMe', price:'Included' },
          { tier:'Network', usage:'1 Gbps', price:'Optional' },
        ],
      }},
    ]},
    { id: 'pricing-dark-hero', label: 'Pricing · Dark Hero',
      _previewShape: 'pricing-dark-hero', preview: '', blocks: [
      { type: 'services', layout: 'pricing-dark-hero', content: {
        title: 'Pick your plan', tagline: 'Power up your business with the right tier.',
        image_url: 'https://images.unsplash.com/photo-1517816743773-6e0fd518b4a6?w=1600&q=80',
        tiers: [
          { name:'Starter', price:'$9', features:['Up to 3 projects','Email support'] },
          { name:'Pro', price:'$29', features:['Unlimited projects','Priority support','Custom domain'], highlighted:true },
          { name:'Master', price:'$99', features:['Everything in Pro','API access','Dedicated CSM'] },
        ],
      }},
    ]},
    { id: 'pricing-middle-pop', label: 'Pricing · Middle Highlighted',
      _previewShape: 'pricing-middle-pop', preview: '', blocks: [
      { type: 'services', layout: 'pricing-highlighted-middle', content: {
        title: 'Simple, flexible pricing',
        tiers: [
          { name:'Starter', price:'$0', features:['Up to 3 projects','Basic analytics'] },
          { name:'Pro', price:'$19', features:['Unlimited projects','Advanced analytics','Custom domain'] },
          { name:'Master', price:'$49', features:['Everything in Pro','API access','White-label'] },
        ],
      }},
    ]},
    { id: 'pricing-membership', label: 'Membership Card',
      _previewShape: 'pricing-membership', preview: '', blocks: [
      { type: 'services', layout: 'pricing-membership', content: {
        title: 'Membership', tagline: 'Join the inner circle. Members get early access + monthly drops.',
        tiers: [
          { name:'Monthly', price:'$19', description:'Cancel anytime' },
          { name:'Annual', price:'$190', description:'2 months free' },
        ],
        buttons: [{ text:'Become a member' }],
      }},
    ]},
    // ── Iter 189c Phase B — new premium Pricing variants ──
    { id: 'pricing-with-testimonial', label: 'Pricing + Testimonial',
      _previewShape: 'pricing-with-testimonial', preview: '', blocks: [
      { type: 'services', layout: 'pricing-with-testimonial', content: {
        eyebrow: 'PRICING', title: 'Pick the plan that fits.', tagline: 'Every plan includes a 14-day free trial.',
        tiers: [
          { name:'Starter', price:'$0',  features:['Up to 3 projects','Basic analytics','Community support'], cta_label:'Start free' },
          { name:'Pro',     price:'$29', features:['Unlimited projects','Advanced analytics','Priority support','Custom domain'], highlighted:true, cta_label:'Try Pro' },
          { name:'Studio',  price:'$99', features:['Everything in Pro','White-label','API access','Dedicated CSM'], cta_label:'Contact us' },
        ],
        testimonial: {
          quote: "\"Pro paid for itself in a week. My whole team is on it now.\"",
          author: 'Sam Rivera', role: 'Head of Design, Kindred',
          image_url: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&q=80',
        },
      }},
    ]},
    { id: 'pricing-annual-toggle', label: 'Pricing · Annual Toggle',
      _previewShape: 'pricing-annual-toggle', preview: '', blocks: [
      { type: 'services', layout: 'pricing-annual-toggle-visual', content: {
        eyebrow: 'BILLING', title: 'One price. All the features.',
        default_period: 'monthly', savings_pill: 'Save 20%', middle_savings_text: 'Save $60/year',
        tiers: [
          { name:'Starter', price:'$9',  description:'For solo founders.', features:['Everything you need to start','Community support'], cta_label:'Start' },
          { name:'Pro',     price:'$29', description:'For growing teams.', features:['Everything in Starter','Priority support','Team access'], highlighted:true, cta_label:'Choose Pro' },
          { name:'Studio',  price:'$79', description:'For agencies.',      features:['Everything in Pro','API access','White-label'], cta_label:'Contact us' },
        ],
      }},
    ]},
  ],

  // ── NEW Phase 2: Auth / Account ────────────────────────────────────────
  'auth-account': [
    { id: 'auth-signup-card', label: 'Sign Up · Card',
      _previewShape: 'auth-signup-card', preview: '', blocks: [
      { type: 'form', layout: 'auth-signup', content: {
        title: 'Create an Account', tagline: 'Join our growing community.',
      }},
    ]},
    { id: 'auth-signin-card', label: 'Sign In · Card',
      _previewShape: 'auth-signin-card', preview: '', blocks: [
      { type: 'form', layout: 'auth-signin', content: { title: 'Sign In' } },
    ]},
    { id: 'auth-signup-split', label: 'Sign Up · Image Split',
      _previewShape: 'auth-signup-split', preview: '', blocks: [
      { type: 'split', layout: 'split-form', content: {
        title: 'Sign up to discover features', image_url: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1200&q=80',
        fields: ['Name','Email','Password'], buttons: [{ text: 'Get Started' }],
      }},
    ]},
    { id: 'auth-signup-mountain', label: 'Sign Up · Mountain Card Hero',
      _previewShape: 'auth-signup-mountain', preview: '', blocks: [
      { type: 'hero', layout: 'mountain-card', content: {
        title: 'Easy to setup. Easy to maintain.', eyebrow: 'Sign Up Now',
        image_url: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1600&q=80',
        fields: ['Email','Password'], buttons: [{ text: 'Get Started' }],
      }},
    ]},
    { id: 'auth-payment-method', label: 'Payment Method',
      _previewShape: 'auth-payment-method', preview: '', blocks: [
      { type: 'form', layout: 'payment-method', content: {
        title: 'Choose Your Payment Method', tagline: 'Your card is encrypted end-to-end.',
        submit_label: 'Pay Securely',
      }},
    ]},
    { id: 'auth-billing', label: 'Billing Account',
      _previewShape: 'auth-billing', preview: '', blocks: [
      { type: 'form', layout: 'billing-account', content: {
        title: 'Create Billing Account', submit_label: 'Save Account',
      }},
    ]},
  ],

  // ── Phase 3: Footers ───────────────────────────────────────────────────
  footer: [
    { id: 'footer-minimal', label: 'Minimal Centered',
      _previewShape: 'footer-minimal', preview: '', blocks: [
      { type: 'footer', layout: 'minimal-centered', content: { brand: 'Your Brand', tagline: 'Crafted with care.' }},
    ]},
    { id: 'footer-multi-column', label: 'Multi-Column · White',
      _previewShape: 'footer-multi-column', preview: '', blocks: [
      { type: 'footer', layout: 'multi-column-white', content: { brand: 'Your Brand', tagline: 'Crafted with care.' }},
    ]},
    { id: 'footer-dark', label: 'Multi-Column · Dark',
      _previewShape: 'footer-dark', preview: '', blocks: [
      { type: 'footer', layout: 'multi-column-dark', content: { brand: 'Your Brand', tagline: 'Crafted with care.' }},
    ]},
    { id: 'footer-newsletter', label: 'Newsletter Capture',
      _previewShape: 'footer-newsletter', preview: '', blocks: [
      { type: 'footer', layout: 'newsletter-capture', content: { brand: 'Your Brand', tagline: 'Join our community.' }},
    ]},
    { id: 'footer-cta-bar', label: 'CTA Bar Footer',
      _previewShape: 'footer-cta-bar', preview: '', blocks: [
      { type: 'footer', layout: 'cta-bar', content: { brand: 'Your Brand', cta_title: 'Ready to get started?', cta_label: 'Get Started' }},
    ]},
    { id: 'footer-slim', label: 'Slim Copyright',
      _previewShape: 'footer-slim', preview: '', blocks: [
      { type: 'footer', layout: 'slim-copyright', content: { brand: 'Your Brand' }},
    ]},
    { id: 'footer-list-compact', label: 'List · Compact',
      _previewShape: 'footer-list-compact', preview: '', blocks: [
      { type: 'footer', layout: 'list-compact', content: { brand: 'Your Brand', tagline: 'Crafted with care.' }},
    ]},
    { id: 'footer-nav-social', label: 'Nav Row + Social',
      _previewShape: 'footer-nav-social', preview: '', blocks: [
      { type: 'footer', layout: 'nav-row-social', content: { brand: 'Your Brand' }},
    ]},
    // ── Iter 189c Phase B — new premium Footer variant ─────────────────
    { id: 'footer-mega-menu', label: 'Mega-Menu · Editorial',
      _previewShape: 'footer-mega-menu', preview: '', blocks: [
      { type: 'footer', layout: 'mega-menu', content: {
        brand: 'Your Brand',
        tagline: 'Making the tools we wish existed.',
        featured: {
          eyebrow: 'FROM THE JOURNAL',
          title: 'The state of independent commerce · 2026',
          image_url: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=600&q=80',
          link_text: 'Read the report →',
        },
        columns: [
          { title: 'Product',   links: ['Features', 'Pricing', 'Templates', 'Roadmap'] },
          { title: 'Company',   links: ['About', 'Blog', 'Careers', 'Press'] },
          { title: 'Resources', links: ['Help Center', 'Community', 'Contact', 'API'] },
          { title: 'Legal',      links: ['Privacy', 'Terms', 'Cookies', 'Licenses'] },
        ],
        socials: ['Twitter', 'Instagram', 'LinkedIn'],
      }},
    ]},
  ],

  // ── Phase 3: FAQs ──────────────────────────────────────────────────────
  faq: [
    { id: 'faq-accordion', label: 'Accordion · Classic',
      _previewShape: 'faq-accordion', preview: '', blocks: [
      { type: 'faq', layout: 'accordion', content: { title: 'Frequently asked questions' }},
    ]},
    { id: 'faq-two-column', label: 'Two-Column · Scannable',
      _previewShape: 'faq-two-column', preview: '', blocks: [
      { type: 'faq', layout: 'two-column', content: { title: 'Your questions answered' }},
    ]},
    { id: 'faq-numbered', label: 'Numbered Steps',
      _previewShape: 'faq-numbered', preview: '', blocks: [
      { type: 'faq', layout: 'numbered-steps', content: { title: 'Easy steps to get started', eyebrow: 'How It Works' }},
    ]},
    // ── Iter 189c Phase B — new premium FAQ variant ──────────────────
    { id: 'faq-searchable', label: 'Search + Tabs · Help Center',
      _previewShape: 'faq-searchable', preview: '', blocks: [
      { type: 'faq', layout: 'searchable-tabbed', content: {
        eyebrow: 'HELP CENTER',
        title: 'How can we help?',
        tagline: 'Search our knowledge base or browse by topic.',
        categories: ['All', 'Getting started', 'Billing', 'Account', 'Integrations'],
        items: [
          { question: 'How do I create my first website?', answer: 'Head to Website → Edit Site. Pick a template, drop in your content, and hit Publish.' },
          { question: 'What payment methods do you support?', answer: 'Stripe (all major cards), Apple Pay, Google Pay, and manual bank transfer on select plans.' },
          { question: 'Can I use a custom domain?', answer: 'Yes — connect a domain from Settings → Domains. We handle SSL automatically.' },
          { question: 'How do I invite team members?', answer: 'Go to Settings → Team and add members by email. Assign a role (Owner, Editor, Viewer).' },
        ],
      }},
    ]},
  ],

  // ── Iteration 138: Agency Long-Scroll ──────────────────────────────────
  agency: [
    { id: 'agency-glass-stat-hero', label: 'Glass Stat Hero',
      preview: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=800&q=80', blocks: [
      { type: 'agency_glass_stat', content: {
        eyebrow: 'Trusted Since 2003',
        title: 'Your local experts — answering 24/7',
        tagline: 'Family-owned, fully insured, and rooted in the community.',
        image_url: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=1600&q=80',
        stats: [
          { value: '20+',    label: 'Years Serving' },
          { value: '5,000+', label: 'Happy Clients' },
          { value: '24/7',   label: 'Emergency Calls' },
        ],
        buttons: [
          { text: 'Call Now', link: 'tel:+15550001234' },
          { text: 'Get a Quote', link: '#contact' },
        ],
        accent: '#F97316',
      }},
    ]},
    { id: 'agency-service-cards', label: 'Service Cards · Hover Zoom',
      preview: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800&q=80', blocks: [
      { type: 'agency_service_cards', content: {
        eyebrow: 'What we do', title: 'Services that solve the problem fast',
        tagline: 'Same-day appointments. Up-front pricing. Guaranteed work.',
        items: [
          { title: 'Emergency Repair',          description: 'Same-day service, 24/7 hotline.',          image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=900&q=80' },
          { title: 'Installation',              description: 'New systems with manufacturer warranty.', image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=900&q=80' },
          { title: 'Inspection & Maintenance',  description: 'Annual tune-ups, transparent pricing.',   image: 'https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=900&q=80' },
        ],
        link_text: 'View all services', link: '#services', accent: '#F97316',
      }},
    ]},
    { id: 'agency-cta-band', label: 'Emergency CTA Band',
      preview: 'https://images.unsplash.com/photo-1576670159805-381a4143e025?w=800&q=80', blocks: [
      { type: 'agency_cta_band', content: {
        eyebrow: 'Emergency hotline', title: '24-hour emergency? We answer.',
        tagline: 'A live technician will be at your door within the hour.',
        phone: '(555) 200-7777', note: 'No call-out fees · Family-owned since 2003', accent: '#F97316',
      }},
    ]},
    { id: 'agency-why-grid', label: 'Why Us · 6 Grid',
      preview: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&q=80', blocks: [
      { type: 'agency_why_grid', content: {
        eyebrow: 'Why Choose Us', title: 'Why homeowners keep calling back',
        tagline: 'Six promises we put in writing on every job.',
        items: [
          { icon: '⚡', title: 'Fast Response',     description: 'On-site within 60 minutes inside city limits.' },
          { icon: '🛠️', title: 'Licensed Pros',    description: 'Every tech is bonded, insured & background-checked.' },
          { icon: '💰', title: 'Upfront Pricing',  description: 'No surprises — flat rates quoted before we start.' },
          { icon: '⭐', title: '5-Star Reviewed',  description: 'Hundreds of verified Google reviews back our work.' },
          { icon: '🔧', title: 'Lifetime Warranty', description: 'On parts & labor for all major installations.' },
          { icon: '🌱', title: 'Eco-Friendly',     description: 'Modern, efficient systems that lower your bills.' },
        ],
        accent: '#F97316',
      }},
    ]},
    { id: 'agency-stat-quad', label: 'Stat Quad · Dark Band',
      preview: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80', blocks: [
      { type: 'agency_stat_quad', content: {
        stats: [
          { value: '20+',    label: 'Years in business' },
          { value: '15K+',   label: 'Jobs completed' },
          { value: '4.9★',   label: 'Average rating' },
          { value: '60 min', label: 'Avg response time' },
        ],
        bg_dark: true, accent: '#F97316',
      }},
    ]},
    { id: 'agency-review-badge', label: 'Inline Review Badge',
      preview: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&q=80', blocks: [
      { type: 'agency_review_badge', content: {
        platform: 'Google', rating: '4.9', count: '432', cta: 'Read all reviews', link: '#reviews', accent: '#F97316',
      }},
    ]},
    // PHASE C — full long-scroll template assembled from the 6 blocks
    { id: 'agency-longscroll', label: '⭐ Service Business · Full Long-Scroll',
      preview: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80', blocks: [
      { type: 'agency_glass_stat', content: {
        eyebrow: 'Trusted Since 2003',
        title: 'Your local plumbing & HVAC experts',
        tagline: 'Family-owned, fully insured, answering 24/7.',
        image_url: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=1600&q=80',
        stats: [
          { value: '20+',    label: 'Years Serving' },
          { value: '5,000+', label: 'Happy Clients' },
          { value: '24/7',   label: 'Emergency Calls' },
        ],
        buttons: [
          { text: 'Call Now',    link: 'tel:+15550001234' },
          { text: 'Get a Quote', link: '#contact' },
        ],
        accent: '#F97316',
      }},
      { type: 'agency_review_badge', content: {
        platform: 'Google', rating: '4.9', count: '432', cta: 'Read all reviews', link: '#reviews', accent: '#F97316',
      }},
      { type: 'agency_service_cards', content: {
        eyebrow: 'What we do', title: 'Services that solve the problem fast',
        tagline: 'Same-day appointments. Up-front pricing. Guaranteed work.',
        items: [
          { title: 'Emergency Repair',          description: 'Same-day service, 24/7 hotline.',          image: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=900&q=80' },
          { title: 'Installation',              description: 'New systems with manufacturer warranty.', image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=900&q=80' },
          { title: 'Inspection & Maintenance',  description: 'Annual tune-ups, transparent pricing.',   image: 'https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=900&q=80' },
        ],
        link_text: 'View all services', link: '#services', accent: '#F97316',
      }},
      { type: 'agency_why_grid', content: {
        eyebrow: 'Why Choose Us', title: 'Why homeowners keep calling back',
        tagline: 'Six promises we put in writing on every job.',
        items: [
          { icon: '⚡', title: 'Fast Response',     description: 'On-site within 60 minutes inside city limits.' },
          { icon: '🛠️', title: 'Licensed Pros',    description: 'Every tech is bonded, insured & background-checked.' },
          { icon: '💰', title: 'Upfront Pricing',  description: 'No surprises — flat rates quoted before we start.' },
          { icon: '⭐', title: '5-Star Reviewed',  description: 'Hundreds of verified Google reviews back our work.' },
          { icon: '🔧', title: 'Lifetime Warranty', description: 'On parts & labor for all major installations.' },
          { icon: '🌱', title: 'Eco-Friendly',     description: 'Modern, efficient systems that lower your bills.' },
        ],
        accent: '#F97316',
      }},
      { type: 'agency_stat_quad', content: {
        stats: [
          { value: '20+',    label: 'Years in business' },
          { value: '15K+',   label: 'Jobs completed' },
          { value: '4.9★',   label: 'Average rating' },
          { value: '60 min', label: 'Avg response time' },
        ],
        bg_dark: true, accent: '#F97316',
      }},
      { type: 'testimonials', layout: 'happy-clients-quadgrid', content: {
        title: 'Loved by neighbors near you',
        items: [
          { author: 'Sarah K.',  role: 'Homeowner',   quote: 'They had a tech at my door in 45 minutes on a Sunday.' },
          { author: 'Marcus T.', role: 'Property mgr', quote: 'Honest pricing, top-notch work. Our go-to crew.' },
          { author: 'Lena R.',   role: 'Homeowner',   quote: 'Professional, kind, and saved us thousands.' },
          { author: 'Jordan P.', role: 'Contractor',  quote: 'I subcontract them on every install. They never miss.' },
        ],
      }},
      { type: 'agency_cta_band', content: {
        eyebrow: 'Emergency hotline', title: '24-hour emergency? We answer.',
        tagline: 'A live technician will be at your door within the hour.',
        phone: '(555) 200-7777', note: 'No call-out fees · Family-owned since 2003', accent: '#F97316',
      }},
      { type: 'contact', layout: 'split-form-aside', content: {
        title: 'Schedule a free estimate',
        tagline: 'Tell us what is going on — we will reply within the hour.',
        image_url: 'https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=1200&q=80',
        info: { address: '123 Main St, Your Town', phone: '(555) 200-7777', email: 'hello@yourservice.com' },
      }},
    ]},
  ],

  // ── Phase 3: Contact (10 dedicated variants) ───────────────────────────
  contact: [
    { id: 'contact-centered', label: 'Centered Card',
      _previewShape: 'contact-centered', preview: '', blocks: [
      { type: 'contact', layout: 'centered-card', content: { title: 'Get In Touch' }},
    ]},
    { id: 'contact-photo-overlay', label: 'Photo Overlay · Big',
      _previewShape: 'contact-photo-overlay', preview: '', blocks: [
      { type: 'contact', layout: 'photo-overlay', content: { title: "Let's Talk", image_url: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=1600&q=80' }},
    ]},
    { id: 'contact-split-aside', label: 'Split · Photo Aside',
      _previewShape: 'contact-split-aside', preview: '', blocks: [
      { type: 'contact', layout: 'split-form-aside', content: { title: 'Get In Touch', image_url: 'https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=1200&q=80' }},
    ]},
    { id: 'contact-map-top', label: 'Map on Top',
      _previewShape: 'contact-map-top', preview: '', blocks: [
      { type: 'contact', layout: 'map-top', content: { title: 'Drop Us a Line' }},
    ]},
    { id: 'contact-chips', label: 'Form + Info Chips',
      _previewShape: 'contact-chips', preview: '', blocks: [
      { type: 'contact', layout: 'chips-below', content: { title: 'Get In Touch with Us' }},
    ]},
    { id: 'contact-map-right', label: 'Map on Right',
      _previewShape: 'contact-map-right', preview: '', blocks: [
      { type: 'contact', layout: 'map-right', content: { title: 'You Can Mail Us' }},
    ]},
    { id: 'contact-dark-mini', label: 'Dark Mini · Mail Us',
      _previewShape: 'contact-dark-mini', preview: '', blocks: [
      { type: 'contact', layout: 'dark-mini', content: { title: 'For any questions please mail us' }},
    ]},
    { id: 'contact-two-col-info-card', label: 'Form + Info Card + Map',
      _previewShape: 'contact-two-col-info-card', preview: '', blocks: [
      { type: 'contact', layout: 'two-col-with-info-card', content: {
        title: 'You Can Mail Us',
        info: { address: '123 Main St, Toronto, ON', phone: '+1 (555) 123-4567', email: 'hello@example.com' },
      }},
    ]},
    // ── Iter 189c Phase B — new premium Contact variant ────────────────
    { id: 'contact-chat-invite', label: 'Chat-Invite Hero',
      _previewShape: 'contact-chat-invite', preview: '', blocks: [
      { type: 'contact', layout: 'chat-invite', content: {
        title: 'Real people. Real replies.',
        subtitle: 'Send a message, expect a reply within an hour during business hours.',
        info: { email: 'hello@example.com', phone: '+1 (555) 123-4567', address: '123 Main St · Toronto' },
      }},
    ]},
  ],
  // ── Iter 189c Phase B · CTA category (8 visually-distinct layouts) ──
  cta: [
    { id: 'cta-default-dark', label: 'Dark Banner', _previewShape: 'cta-default-dark', preview: '', blocks: [
      { type: 'cta', content: {
        title: 'Ready to build something remarkable?',
        subtitle: 'Book a call and we\'ll map out the first ninety days together.',
        buttons: [{ text: 'Book a Call', link: '#' }, { text: 'See Case Studies', link: '#' }],
      } },
    ]},
    { id: 'cta-image-hero', label: 'Image Hero', _previewShape: 'cta-image-hero', preview: '', blocks: [
      { type: 'cta', layout: 'image-cta', content: {
        title: 'Bring your next project to life.',
        subtitle: 'Our studio partners with founders and marketers who care about craft.',
        image_url: 'https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=1600&q=80',
        buttons: [{ text: 'Start a Project', link: '#' }],
      } },
    ]},
    { id: 'cta-pill-bar', label: 'Pill Bar', _previewShape: 'cta-pill-bar', preview: '', blocks: [
      { type: 'cta', layout: 'pill-bar', content: {
        title: 'Get 15% off your first order',
        subtitle: 'Sign up to our newsletter and unlock the launch discount.',
        buttons: [{ text: 'Subscribe', link: '#' }],
      } },
    ]},
    { id: 'cta-mountain-overlay', label: 'Mountain Overlay', _previewShape: 'cta-mountain-overlay', preview: '', blocks: [
      { type: 'cta', layout: 'mountain-overlay', content: {
        title: 'Reach new heights this quarter.',
        subtitle: 'Everything you need to grow — one platform, zero platform fees.',
        image_url: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1600&q=80',
        buttons: [{ text: 'Start Free', link: '#' }, { text: 'Watch Demo', link: '#' }],
      } },
    ]},
    { id: 'cta-slim-promo-bar', label: 'Slim Promo Bar', _previewShape: 'cta-slim-promo-bar', preview: '', blocks: [
      { type: 'cta', layout: 'slim-promo-bar', content: {
        title: 'Spring sale — 30% off everything through Sunday.',
        buttons: [{ text: 'Shop the Sale', link: '#' }],
      } },
    ]},
    { id: 'cta-app-store-badges', label: 'App Store Badges', _previewShape: 'cta-app-store-badges', preview: '', blocks: [
      { type: 'cta', layout: 'app-store-badges', content: {
        title: 'Take it on the go.',
        subtitle: 'Download the app and manage everything from your phone.',
        image_url: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=900&q=80',
      } },
    ]},
    { id: 'cta-video-modal', label: 'Video · Modal', _previewShape: 'cta-video-modal', preview: '', blocks: [
      { type: 'cta', layout: 'video-modal-cta', content: {
        title: 'See it in motion.',
        subtitle: 'A 90-second tour of what makes our platform different.',
        image_url: 'https://images.unsplash.com/photo-1522252234503-e356532cafd5?w=1600&q=80',
        buttons: [{ text: 'Watch Now', link: '#' }],
      } },
    ]},
    { id: 'cta-white-bordered-card', label: 'White Bordered Card', _previewShape: 'cta-white-bordered-card', preview: '', blocks: [
      { type: 'cta', layout: 'white-bordered-card', content: {
        title: 'Talk to our team',
        subtitle: 'We reply within one business day. No sales scripts, just answers.',
        buttons: [{ text: 'Contact Sales', link: '#' }],
      } },
    ]},
  ],
};
